import { Box } from '@mui/material';
import { styled } from '@mui/material/styles';

interface ColorDotProps {
  color: string;
}

export const ColorDot = styled(Box)<ColorDotProps>(({ color }) => ({
  height: 18,
  minWidth: 18,
  borderRadius: 50,
  background: color,
}));

export const StyledList = styled(Box)(({ theme }) => ({
  minHeight: '480px',
  borderRadius: '8px',
  overflowX: 'hidden',
  '&::-webkit-scrollbar': {
    width: 8,
    height: 0,
  },
  '&::-webkit-scrollbar-thumb': {
    backgroundColor: theme.palette.secondary.main,
    borderRadius: 12,
    '&:hover': {
      backgroundColor: theme.palette.secondary.dark,
    },
  },
  '&::-webkit-scrollbar-track': {
    margin: '10px 0',
  },
  '@media (max-height: 820px)': {
    minHeight: 360,
  },
}));

export const checkboxStyle = {
  '&.Mui-checked': {
    color: '#595959',
  },
};
